<template>
  <v-container class="pa-0">
    <app-loading :loading="loading">
      <div>
        <app-grammar-introduction
          :data="data.grammar_intro"
          v-if="intro"
          @next-step="skipGrammar"
          @prev-step="$emit('prev-step')"
        />
        <div v-else>
          <keep-alive>
            <component
              :is="data.exercises[current].ex_type"
              :number="current + 1"
              :maxStep="data.exercises.length"
              :data="data.exercises[current]"
              @next-exercise="onNext"
              @prev-exercise="onPrev"
              :key="'exercise' + current"
            />
          </keep-alive>
        </div>
      </div>
    </app-loading>
    <app-qualification
      v-if="!intro && isTeacher && !qualification.note && qualification.uuid"
      :qualification="qualification"
      @new-qual="qualification = $event"
    />
    <app-qualification-dialog
      v-model="dialog"
      :qualification="qualification"
      @new-qual="qualification = $event"
      @input="onInput"
    />
  </v-container>
</template>
<script>
import GrammarIntroduction from "./GrammarIntroduction.vue";
import Loading from "@/components/Loading.vue";
import Qualification from "@/components/Utils/Qualification.vue";
import QualificationDialog from "@/components/Utils/QualificationDialog.vue";
import { getLessonGrammar, patchLessonProgress } from "@/api/api";
import studentMixin from "@/mixins/studentMixin";
import directionMixin from "@/mixins/directionMixin";

export default {
  components: {
    appGrammarIntroduction: GrammarIntroduction,
    appLoading: Loading,
    appQualification: Qualification,
    appQualificationDialog: QualificationDialog,
  },
  mixins: [studentMixin, directionMixin],
  data() {
    return {
      intro: this.$route.query.gn === undefined,
      current: Number.parseInt(this.$route.query.gn) || 0,
      data: {},
      loading: true,
      qualifications: [],
      qualification: {},
      dialog: false,
    };
  },
  methods: {
    async skipGrammar(payload) {
      if (payload === true) {
        this.updateProgressAndNext();
      } else this.intro = false;
    },
    updateProgressAndNext() {
      let progress = this.$store.getters["progress/lesson"];
      if (!progress.teach_progress.grammar_step.completed) {
        progress.teach_progress.grammar_step.completed = true;
        patchLessonProgress(progress).then((response) => {
          this.$store.commit("progress/lesson", response.data);
        });
      }
      this.$emit("next-step");
    },
    async onNext() {
      this.nextStep();
    },
    onPrev() {
      if (this.current > 0) {
        this.current--;
      } else {
        this.intro = true;
      }
    },
    onInput(e) {
      if (!e) {
        this.nextStep();
      }
    },
    nextStep() {
      let progress = this.$store.getters["progress/lesson"];
      const exercise = progress.teach_progress.grammar_step.exercises.find(
        (element) => element.exercise === this.data.exercises[this.current].uuid,
      );
      if (!exercise.completed) {
        exercise.completed = true;
        patchLessonProgress(progress).then((response) => {
          this.$store.commit("progress/lesson", response.data);
        });
      }

      if (this.current < this.data.exercises.length - 1) {
        this.current++;
      } else {
        this.updateProgressAndNext();
      }
    },
  },
  watch: {
    intro(value) {
      this.$router.replace({
        query: { ...this.$route.query, gn: value ? undefined : this.current },
      });
    },
    current(value) {
      this.$router.replace({
        query: { ...this.$route.query, gn: value },
      });
      this.qualification = this.qualifications[value];
    },
  },
  async created() {
    this.loading = true;
    const response = await getLessonGrammar(
      this.$store.getters["lesson/teacher_lesson"].grammar_step,
    );
    let data = response.data;
    data.grammar_intro.rich_text = JSON.parse(response.data.grammar_intro.rich_text);
    this.data = data;

    for (let index = 0; index < data.exercises.length; index++) {
      const element = data.exercises[index];
      const qualification = await this.fetchQualification(
        this.student.email,
        element.question_group.uuid,
      );
      this.qualifications.push(qualification);
    }
    if (this.qualifications[0]) {
      this.qualification = this.qualifications[0];
    }

    data.exercises.forEach((element) => {
      if (!this.$options.components[element.ex_type]) {
        this.$options.components[element.ex_type] = () =>
          import(`@/components/Lessons/Lesson/Grammar/${element.ex_type}.vue`);
      }
    });
    this.loading = false;
  },
};
</script>
